module.exports = __webpack_public_path__ + "img/eabl-bg@2x.f9165d04.png";